import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../../services/SellingService";
import WarehouseService from "../../../services/WarehouseService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { Snackbar, TextField } from "@material-ui/core";
import PackService from "../../../services/PackService";
import { useNavigate } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import withLoader from "../../../components/layouts/WithLoader";

const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiStepIcon-root.MuiStepIcon-active ": {
            width: "100%",
            color: "#000000",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
            color: "#000000",
        },
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    icon: {
        color: "#000",
    },
}));
function getSteps() {
    return ["Inscrivez les produits ", "Créer un pack ", "Finaliser"];
}
const AddPack = ({startLoading,stopLoading}) => {
    const animatedComponents = makeAnimated();
    const [selectedOption, setSelectedOption] = useState(null);
    const [warehouseSourceId, setWarehouseSourceId] = useState(0);
    const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
        useState("Choisir...");
    const [productBloc, setProductBloc] = useState(false);
    const [allProducts, setAllProducts] = useState([{}]);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
    const [warehousesSource, setWarehousesSource] = useState([]);
    const [productId, setProductId] = useState(0);
    const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
        useState("Choisir...");
    const [estimUnitPrice, setEstimUnitPrice] = useState("");
    const [estimQte, setEstimQte] = useState("");
    const [estimTva, setEstimTva] = useState("");
    const [estimDevise, setEstimDevise] = useState("");
    const [unitPrice, setUnitPrice] = useState(0);
    const [price, setPrice] = useState(0);

    const [montantDevis, setMontantDevis] = useState(0);
    const [tva, setTva] = useState(0);
    const [labelDevise, setLabelDevise] = useState("Prix en DNT");
    const [quantity, setQuantity] = useState(0);
    const [productMapById, setProductMapById] = useState([]);
    const [modeProduct, setModeProduct] = useState(null);
    const [promotionType, setPromotionType] = useState("pourcentage");
    const [deviseChoosen, setDeviseChoosen] = useState(null);
    const [tauxChange, setTauxChange] = useState(0);
    const [productTableData, setProductTableData] = useState([]);
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [infoAlertText, setInfoAlertText] = useState();
    const [promotionPercentage, setPromotionPercentage] = useState(0);
    const [selectedOptionMode, setSelectedOptionMode] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [namePack, setNamePack] = useState("");
    const [refPack, setRefPack] = useState("");
    const [startDate, setStartDate] = useState("any");
    const [endDate, setEndDate] = useState("any");
    const [typeProduct, setTypeProduct] = useState();
    const classes = useStyles();
    const steps = getSteps();
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [maxQtePack, setMaxQtePack] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        startLoading();
        WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
            .then((response) => {
                if (response.data.success) {
                    setWarehousesSource(response.data.success);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : pas de dépôt");
                }
            })
            .catch((e) => {
                console.log("error in getAllRealWarehouse", e);
            }).finally(() => {
                stopLoading()
            });
    }, []);
    useEffect(() => {
        warehousesSource &&
            warehousesSource.map((element) => {
                let exist = false;
                if (allWarehouseSource.length !== 0) {
                    for (let index = 0; index < allWarehouseSource.length; index++) {
                        if (allWarehouseSource[index].value === element?.id) {
                            exist = true;
                            break;
                        }
                    }
                }
                if (element?.id !== undefined && exist === false) {
                    setAllWarehouseSource((oldArray) => [
                        ...oldArray,
                        { value: element.id, label: element.name },
                    ]);
                }
                //here
            });
    }, [warehousesSource]);

    const onChangeSelectedWarehouseSource = (selectedOptionn) => {
        setSelectedOption();
        setWarehouseSourceId(selectedOptionn.value);
        setWarehouseSelectPlaceHolder(selectedOptionn.label);
        // console.log("warehouseSourceID", selectedOptionn.value);
    };
    const getProdcutsByWarehouse = (event) => {
        if (warehouseSourceId !== 0) {
            setProductBloc(true);

            startLoading();
            SellingService.getAllProductsOnSaleForCreatingPack(
                getCurrentUserId(),
                1,
                warehouseSourceId
            )
                .then((response) => {
                    if (response.data.success) {
                        // console.log("getAllProductsOnSale", response.data.success);
                        // setWarehousesSource(response.data.success);
                        console.log(response.data.success);
                        setAllProducts([{}]);
                        // setAvailableProducts(response.data.success);

                        response.data.success &&
                            response.data.success.map((element) => {
                                let exist = false;
                                if (allProducts.length !== 0) {
                                    for (let index = 0; index < allProducts.length; index++) {
                                        if (allProducts[index].value === element.product?.id) {
                                            exist = true;
                                            break;
                                        }
                                    }
                                }
                                let codeProduct = "*";
                                if (element.product.productCode !== undefined) {
                                    codeProduct = element.product.productCode;
                                }
                                let barCodeProduct = "*";
                                if (element.product.barcode) {
                                    barCodeProduct = element.product.barcode;
                                }
                                let label =
                                    codeProduct +
                                    "-" +
                                    barCodeProduct +
                                    "-" +
                                    element.product.name;
                                if (element.product?.id !== undefined && exist === false) {
                                    setAllProducts((oldArray) => [
                                        ...oldArray,
                                        {
                                            value: element.product.id,
                                            label: label,
                                            customElements: {
                                                quantity: element.quantity,
                                                tva: element.product.tva,
                                                price: element.priceSale,
                                                devise: element.devise,
                                                typeProduct: element.product.typeProduct
                                            },
                                        },
                                    ]);
                                    setAvailableProducts((oldArray) => [
                                        ...oldArray,
                                        element.product,
                                    ]);
                                }
                            });
                    } else {
                        setOpenInfoAlert(true);
                        setInfoAlertText("Dépôt est vide");
                    }
                })
                .catch(() => {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : il ya un probléme de connexion");
                }).finally(()=>{
                    stopLoading();
                });
        }
    };
    const onChangeSelectedProduct = (selectedOptionn) => {
        console.log("selectedOptionn", selectedOptionn);
        setSelectedOption();
        setProductId(selectedOptionn.value);
        setProductSelectPlaceHolder(selectedOptionn.label);
        setEstimUnitPrice(selectedOptionn.customElements.price);
        setEstimQte(selectedOptionn.customElements.quantity);
        setEstimTva(selectedOptionn.customElements.tva + "%");
        setUnitPrice(selectedOptionn.customElements.price);
        setMontantDevis(selectedOptionn.customElements.price);
        setTva(selectedOptionn.customElements.tva);
        setEstimDevise(selectedOptionn.customElements.devise);
        setTypeProduct(selectedOptionn.customElements.typeProduct)
        if (selectedOptionn.customElements.typeProduct === 1) {
            setEstimQte(selectedOptionn.customElements.quantity);
        } else if (selectedOptionn.customElements.typeProduct === 2) {
            setEstimQte("service");
        }


    };
    const maxQuantityPack = (quantityChosen, allQuantity) => {

        return allQuantity / quantityChosen
    }

    const columns = [
        {
            dataField: "productRef",
            text: "Libellé",
            headerAlign: "center",
        },

        {
            dataField: "quantity",
            text: "Quantité",
            align: "center",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "idProduct",
            text: "Supprimer",
            headerStyle: () => {
                return { width: "15%" };
            },
            formatter: (cell, row, rowIndex, extraData) => (
                <span>
                    <button className="btn btn-danger">
                        <i class="fas fa-trash"></i>
                    </button>
                </span>
            ),
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    console.log("productTableData", productTableData);

                    setProductTableData(
                        productTableData.filter((item) => item.idProduct !== row.idProduct)
                    );
                },
            },
        },
    ];
    function etatInitial() {
        setSelectedOption(null);
        setProductSelectPlaceHolder("Choisir...");
        setUnitPrice(0);
        setQuantity(0);
        setTva(0);
        setSelectedOptionMode(null);
        setPromotionType("pourcentage");
        setPromotionPercentage(0);
        // setSelectedOptionLot(null);
        // setClientSelectedOption(null);
        // setLotSelectPlaceHolder("Choisir...");
    }
    const onAddProductToList = (event) => {
        let productRef = null;
        let exist = false;
        let indexInDataTable;
        try {
            productMapById.forEach((element, index) => {
                if (element.id === productId) {
                    indexInDataTable = index;
                    exist = true;
                    throw "Break";
                }
            });
        } catch (e) {
            if (e !== "Break") throw e;
        }

        try {
            availableProducts.forEach((element) => {
                if (element.id === productId) {
                    productRef = element.name;
                    throw "Break";
                }
            });
        } catch (e) {
            if (e !== "Break") throw e;
        }
        if (productId === 0) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Sélectionnez un produit ");
        } else if (quantity === 0) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Sélectionnez une quantité ");
        } else {
            console.log("typeProduct", typeProduct);
            console.log("maxQtePack", maxQtePack);

            if (typeProduct === 1) {
                console.log("quantity", quantity);
                console.log("estimQte", estimQte);
                let qtePack = maxQuantityPack(quantity, estimQte)
                console.log("qtePack", qtePack);



                if (maxQtePack === null) {
                    setMaxQtePack(qtePack);
                } else if (maxQtePack > qtePack) {
                    setMaxQtePack(qtePack);
                }
            }


            setProductMapById((previoustate) => [
                ...previoustate,
                {
                    productRef: productRef,
                    quantity: quantity,
                    idProduct: productId,

                },
            ]);
            setProductTableData((previoustate) => [
                ...previoustate,
                {
                    productRef: productRef,
                    quantity: quantity,
                    idProduct: productId,

                },
            ]);
        }

        etatInitial();
    };
    function handleTableChange({ productTableData }) {
        return productTableData;
    }
    const handlerChangeQt = (event) => {
        if(typeProduct===1){
            if (event.target.value > estimQte) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : quantité superieur à ce qui est disponible ");
            } else {
                setQuantity(event.target.value);
    
            }
        }else{
            setQuantity(event.target.value);

        }
       
    };

    function blocProducts() {
        if (productBloc && warehouseSourceId !== 0) {
            return (
                <div>

                    <div class="row">
                        <div className="col-sm-8">
                            <div className="form-group">
                                <label>Choisir un produit</label>
                                <Select
                                    closeMenuOnSelect={true}
                                    components={animatedComponents}
                                    defaultValue={selectedOption}
                                    onChange={onChangeSelectedProduct}
                                    options={allProducts}
                                    placeholder={productSelectPlaceHolder}
                                />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div class="form-group">
                                <label>
                                    Choisir la quantité ({estimQte})
                                </label>

                                <input
                                    onChange={handlerChangeQt}
                                    type="number"
                                    min="0"
                                    id="inputClientCompany"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div className="col-sm-12  text-center">
                            <button
                                style={{ marginBottom: 20 }}
                                className="btn btn-dark float-right"
                                onClick={onAddProductToList}
                            >
                                <i class="fas fa-plus"></i>
                                Ajouter{" "}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                {productTableData && (
                                    <ToolkitProvider
                                        keyField="idProduct"
                                        data={productTableData}
                                        columns={columns}
                                        onTableChange={handleTableChange}
                                    >
                                        {(props) => (
                                            <div className="row">
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    striped
                                                    hover
                                                    condensed
                                                />
                                            </div>
                                        )}
                                    </ToolkitProvider>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    const addPack = () => {
        // if (name == null) {
        //     setOpenErrorAlert(true);
        //     setErrorAlertText("Erreur :le nom est vide ! ");
        // } else if (type === 2) {
        //     if (sku === undefined || sku === null || sku === "") {
        //         setOpenErrorAlert(true);
        //         setErrorAlertText("Erreur :la référence est vide ! ");
        //     } else {
        //         let exist = UtilsFormule.testSKUExist(sku, listSkus);
        //         if (exist) {
        //             setOpenErrorAlert(true);
        //             setErrorAlertText("Erreur :la référence existe déjà ! ");
        //         } else {
        //             if (sku.length !== 2) {
        //                 setOpenErrorAlert(true);
        //                 setErrorAlertText("Erreur :la référence doit être deux lettres ! ");
        //             } else {
        //                 let pattern = UtilsFormule.testSKUPattern(sku);
        //                 if (!pattern) {
        //                     setOpenErrorAlert(true);
        //                     setErrorAlertText(
        //                         "Erreur :la référence doit contenir deux lettres majuscules ! "
        //                     );
        //                 }
        //             }
        //         }
        //     }
        // }
        // let familyModel = {
        //     familyName: name,
        //     description: desc,
        //     idUserCreation: getCurrentUserId(),
        //     type: type,
        //     sku: sku,
        // };
        // console.log("familyModel", familyModel);

        // ProductService.addProductFamily(familyModel).then((result) => {
        //     console.log("result", result.data["success"]);
        //     if (result.data["success"]) {
        //         setOpenSuccessAlert(true);
        //         setSuccessAlertText("Enregistrement avec succées");
        //         setTimeout(() => {
        //             navigate(`/families`);
        //         }, 2000);
        //     } else {
        //         setOpenErrorAlert(true);
        //         setErrorAlertText("Erreur :erreur serveur ");
        //     }
        // });
    };
    const handleReset = () => {
        window.location.reload(false);
    };
    const onChangeNamePackHandler = (event) => {
        setNamePack(event.target.value);
    };
    const onChangeRefPackHandler = (event) => {
        setRefPack(event.target.value);
    };
    const onChangePriceHandler = (event) => {
        setPrice(event.target.value);
        // setLabelDevise("Prix U en DNT");
        // setMontantDevis(event.target.value);
    };
    const onChangeQuantityHandler = (event) => {
        if(typeProduct===1){
            if (event.target.value > maxQtePack) {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : quantité superieur à ce qui est disponible ");
            } else {
                setQuantity(event.target.value);
    
            }
        }else{
            setQuantity(event.target.value);

        }
       

    };
    const onChangeStartDate = (event) => {
        setStartDate(event.target.value.concat(":59"));
    };
    const onChangeEndDate = (event) => {
        setEndDate(event.target.value.concat(":59"));
    };
    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div class="row">
                            <div className="col-sm-12">
                                <div className="form-group">
                                    <label>Choisir le dépôt </label>
                                    <div className="input-group">
                                        <div
                                            className="input-group-prepend"
                                            style={{ width: "95%" }}
                                        >
                                            <Select
                                                styles={styles}
                                                closeMenuOnSelect={true}
                                                components={animatedComponents}
                                                defaultValue={selectedOption}
                                                onChange={onChangeSelectedWarehouseSource}
                                                options={allWarehouseSource}
                                                placeholder={warehouseSelectPlaceHolder}
                                            />
                                        </div>
                                        <div className=" input-group-append">
                                            <button
                                                onClick={getProdcutsByWarehouse}
                                                type="button"
                                                class="btn btn-dark"
                                            >
                                                <i class="fas  fa-solid fa-arrow-down"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {blocProducts()}

                    </div>

                );
            case 1:
                return (
                    <div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="inputClientCompany">Référence</label>
                                    <input
                                        value={refPack}
                                        required="required"
                                        onChange={onChangeRefPackHandler}
                                        type="text"
                                        id="inputClientCompany"
                                        className="form-control"
                                        placeholder="Saisir..."
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="inputClientCompany">Titre</label>
                                    <input
                                        value={namePack}
                                        required="required"
                                        onChange={onChangeNamePackHandler}
                                        type="text"
                                        id="inputClientCompany"
                                        className="form-control"
                                        placeholder="Saisir..."
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label>Prix Pack</label>
                                    <input
                                        onChange={onChangePriceHandler}
                                        // type="number"
                                        // value={estimUnitPrice}
                                        value={price}
                                        // disabled="true"
                                        min="0"
                                        id="unitPrice"
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label>Quantité ({maxQtePack}) </label>
                                    <input
                                        onChange={onChangeQuantityHandler}
                                        value={quantity}
                                        type="number"
                                        min="0"
                                        id="quantity"
                                        className="form-control"
                                    />
                                </div>
                            </div></div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="inputName">Date début</label>

                                    <TextField
                                        style={{ width: "100%" }}
                                        className="col-sm-12"
                                        variant="outlined"
                                        value={startDate}
                                        onChange={onChangeStartDate}
                                        id="datetime-local"
                                        type="datetime-local"
                                        defaultValue="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label htmlFor="inputName">Date fin</label>

                                    <TextField
                                        style={{ width: "100%" }}
                                        className="col-sm-12"
                                        variant="outlined"
                                        value={endDate}
                                        onChange={onChangeEndDate}
                                        id="datetime-local"
                                        type="datetime-local"
                                        defaultValue="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </div>


                    </div>
                );
            case 2:
                return (
                    <div className="row">
                        <span class="text-dark">
                            Avant de cliquer sur terminé, vous devez être sûr des informations
                            saisies
                        </span>
                    </div>
                );
            default:
                return "Unknown step";
        }
    }
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    const handleNext = () => {

        if (activeStep === 0 && productTableData.length > 0) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else if (activeStep === 0 && productTableData.length === 0) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Aucun produit ");
        }

        else if (activeStep === 1 && namePack === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Le titre est vide ");
        } else if (activeStep === 1 && refPack === "") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Le référence est vide ");
        } else if (activeStep === 1 && quantity === 0) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : La quantité est vide ");
        } else if (activeStep === 1 && startDate === "any" && endDate === "any") {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : Les dates sont vides ");
        } else if (activeStep === 1) {

            PackService.verifiePackExistanceByReference(
                getCurrentUserId(),
                refPack
            )
                .then((response) => {
                    console.log("response", response)
                    if (response.data["NotExist"]) {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);

                    } else if (response.data["Exist"]) {
                        setOpenInfoAlert(true);
                        setInfoAlertText("Info : ce réference existe ");
                    }
                })
                .catch((e) => {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : " + e);
                });
            // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else if (activeStep === 2) {
            let packAddModel = {
                price: price,
                idUser: getCurrentUserId(),
                namePack: namePack,
                refPack: refPack,
                idWarehouse: warehouseSourceId,
                dateDebut: startDate,
                dateFin: endDate,
                // packProduct: 1,
                // packService: 0,
                // packProductService: 0,
                productPackModels: productTableData,
                quantity: quantity
            };
            PackService.addNewPack(packAddModel).then((result) => {
                console.log("result", result);
                if (result.data["success"]) {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                        navigate(`/pack`);
                    }, 2000);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur :erreur serveur ");
                }
            })
        }
    };


    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };
    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <br />
            <section className="content ">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className={classes.root}>
                                        <Stepper activeStep={activeStep}>
                                            {steps.map((label) => (
                                                <Step key={label}>
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </div>
                                </div>
                                {/* <section className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">Home</li>
                                <li class="breadcrumb-item active">Ajouter pack</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section> */}
                                {/*  */}
                                {activeStep === steps.length ? (
                                    <div className="card-body">
                                        <div class="row" style={{ marginTop: 2 }}>
                                            Toutes les étapes ont été complétées avec succès
                                            <button
                                                className="btn btn-dark float-right"
                                                onClick={handleReset}
                                            >
                                                Réinitialiser
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div class="card-body">{getStepContent(activeStep)}</div>
                                        <div class="card-footer" style={{ marginTop: "1%" }}>
                                            <button
                                                disabled={activeStep === 0}
                                                className="btn btn-light"
                                                onClick={handleBack}
                                            >
                                                Précédent
                                            </button>

                                            <button class="btn btn-dark"
                                                onClick={handleNext}
                                            >
                                                {activeStep === steps.length - 1
                                                    ? "Terminer"
                                                    : "Suivant"}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Snackbar
                    open={openInfoAlert}
                    autoHideDuration={4000}
                    onClose={handleInfoClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert onClose={handleInfoClose} severity="info">
                        {infoAlertText}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openErrorAlert}
                    autoHideDuration={2000}
                    onClose={handleEroorClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert variant="filled" onClose={handleEroorClose} severity="error">
                        {errorAlertText}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openSuccessAlert}
                    autoHideDuration={2000}
                    onClose={handleSuccessClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                        {successAlertText}
                    </Alert>
                </Snackbar>
            </section>
        </div>
    );
};
export default withLoader(AddPack);
